<span class="d-block"><badge [badge]="statusChecklist()"></badge></span>
@if(metadata){
<div class="col mx-5 my-2">
  <span><strong>{{ titulo }}</strong></span><br>
  <span>{{ descricao }}</span>
</div>
}
<editable-form [form]="form!" [noButtons]="!entity_id ? 'true' : undefined" (submit)="onSaveData()" (cancel)="onCancel()">
  <grid [items]="items" #checklist [hasEdit]="true" [hasDelete]="true" [add]="addCheckItem.bind(this)" [form]="formCheckItem" [save]="saveCheckItem.bind(this)" editable>
    <columns>
      <column title="Check" [template]="checkTemplate" [editTemplate]="checkTemplateEdit" [width]="50">
        <ng-template let-row="row" #checkTemplate><span class="d-block text-center"><i [class]="row.checked ? 'bi bi-check-circle text-success' : 'bi bi-x-circle text-danger'"></i></span></ng-template>
        <ng-template let-row="row" #checkTemplateEdit>
          <input-switch scale="small" controlName="checked"></input-switch>
        </ng-template>
      </column>
      <column title="Texto principal" [template]="textoTemplate" [editTemplate]="textoTemplateEdit" [width]="200">
        <ng-template let-row="row" #textoTemplate><span>{{ row.texto || "" }}</span></ng-template>
        <ng-template let-row="row" #textoTemplateEdit>
          <input-text controlName="texto"></input-text>
        </ng-template>
      </column>
      <column title="Detalhamento" [template]="detalhamentoTemplate" [editTemplate]="detalhamentoTemplateEdit">
        <ng-template let-row="row" #detalhamentoTemplate><text-html [html]="row.detalhamento"></text-html></ng-template>
        <ng-template let-row="row" #detalhamentoTemplateEdit>
          <!--<input-editor [size]="8" controlName="detalhamento" [hasToolbar]="false" [height]="20"></input-editor>-->
          <input-editor [size]="8" [height]="20" [hasToolbar]="false" controlName="detalhamento" [control]="formCheckItem!.controls.detalhamento" [mention]="editorService.usuariosMention"></input-editor>
        </ng-template>
      </column>
      <column title="Anotações" [hint]="'Observações inerentes à fase de execução'" [template]="anotacoesTemplate" [editTemplate]="anotacoesTemplateEdit">
        <ng-template let-row="row" #anotacoesTemplate><text-html [html]="row.anotacoes"></text-html></ng-template>
        <ng-template let-row="row" #anotacoesTemplateEdit>
          <!--input-editor [size]="8" controlName="anotacoes" [hasToolbar]="false" [height]="20"></input-editor>-->
          <input-editor [size]="8" [height]="20" [hasToolbar]="false" controlName="anotacoes" [control]="formCheckItem!.controls.anotacoes" [mention]="editorService.usuariosMention"></input-editor>
        </ng-template>
      </column>
      <column type="options"></column>
    </columns>
  </grid>
</editable-form>